module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-18-min.cb307453.jpg";